import imageCompression from "browser-image-compression";

export const generateUniqueFileName = (file) => {
    const ext = file.name.split(".").pop();
    const name = file.name.replace(`.${ext}`, "");
    const uniqueId = `${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

    return new File([file], `${name}_${uniqueId}.${ext}`, {
        type: file.type,
    });
};

export const compressImage = async (file) => {
    const options = {
        maxSizeMB: 1,
        maxWidthOrHeight: 1920,
        useWebWorker: true,
        initialQuality: 0.85,
    };

    const compressedFile = await imageCompression(file, options);
    return compressedFile;
};

export const processImage = async (file) => {
    const compressed = await compressImage(file);
    return generateUniqueFileName(compressed);
};



export const getStoredArray = (key) => {
    try {
        const value = localStorage.getItem(key);
        if (!value) return [];

        return Array.isArray(value.split(",")) ? value.split(",") : [];
    } catch {
        return [];
    }
};